import * as Sentry from "@sentry/react";
import { config } from "JS/Config";
import { BrowserTracing } from "@sentry/tracing";
import { isBetaEnvironment } from "./Helpers";

const benignIdbMessages = [
    "the database connection is closing",
    "connection to indexed database server lost",
];

const registerBenignIdbRejectionHandler = () => {
    window.addEventListener("unhandledrejection", (event) => {
        const reason = event.reason;
        const message = (reason?.message || "").toLowerCase();
        if (
            reason?.name === "InvalidStateError" &&
            benignIdbMessages.some((m) => message.includes(m))
        ) {
            event.preventDefault();
            console.warn("Ignored benign IndexedDB error:", reason.message);
        }
    });
};

export const sentryInit = () => {
    registerBenignIdbRejectionHandler();
    Sentry.init({
        dsn: config.sentry.dsn,
        integrations: [new BrowserTracing()],
        environment: config.sentry.environment,
        tracesSampleRate: config.sentry.traceSampleRate,
        release:
            isBetaEnvironment()
                ? config.betaAppVersion
                : config.appVersion,
        attachStacktrace: true,
    });
};

export const initializeSentryUser = () => {
    Sentry.setUser({
        id: config.user.memberId,
    });
};

export const captureSentryError = (
    error: Error,
    tags?: { [key: string]: string },
) => {
    Sentry.captureException(error, {
        tags: tags,
    });
};
